module.exports = __webpack_public_path__ + "img/paved_asphalted_and_unstabilized.6aa75cf0.png";